<!-- eslint-disable radix -->
<!--
 * @Date: 2022-09-13 19:19:03
 * @LastEditTime: 2022-12-23 14:25:59
 * @Description: file content
-->
<template>
  <cube-sticky :pos="scrollY" :check-top="checkTop">
    <div ref="qingxinWrap" class="qingxin-wrap" @scroll="scrollHandler">
      <div class="bg-wrap">
        <div class="qx-bg" />
        <cube-sticky-ele>
          <div class="prepend-header">
            <ul ref="tabList">
              <template v-for="(item, index) in list">
                <li
                  v-if="!!Number(item.tab_show) && tabImgList[item.unique_key]"
                  ref="tabItem"
                  :key="index"
                  :class="{ active: current == item.unique_key }"
                  @click="handleTabs(item)"
                >
                  <img
                    v-if="current == item.unique_key"
                    :src="tabImgList[item.unique_key].active"
                    alt=""
                  />
                  <img
                    v-else
                    :src="tabImgList[item.unique_key].normal"
                    alt=""
                  />
                </li>
              </template>
            </ul>
          </div>
        </cube-sticky-ele>
        <div
          v-for="(item, index) in list"
          :id="item.unique_key"
          :key="index"
          :label="item.unique_key"
          :title="item.title"
        >
          <div
            v-if="item.unique_key === 'tanks_word_info'"
            id="tanks_word_info"
            class="tanks-word-info"
            :style="{ backgroundImage: 'url(' + item.top_lottery_image + ')' }"
          >
            <img
              class="to-lottery"
              src="https://staff.chunyu.mobi/@/media/images/2022/12/07/6eee/8fb339e5480a_w203_h428_.png"
              @click="
                jumpAppOrH5(item.top_lottery_url, {
                  click_position: item.click_position_name,
                })
              "
            />
            <img
              v-show="showAddOne"
              class="add-one"
              src="https://resource.chunyu.mobi/@/media/images/2022/12/14/65e6/e905797cd062_w159_h52_.png"
              alt=""
            />
            <div class="bullet-screen">
              <VBarrage
                :arr="bulletLists"
                :is-pause="bulletChat.isPause"
                :percent="100"
                direction="default"
                :bullet-chat-one.sync="sendBulletChatOne"
              />
              <div class="input-wrap">
                <textarea
                  id="textarea"
                  v-model="text"
                  type="text"
                  maxlength="50"
                  :placeholder="showPlaceHolder ? item.placeholder_words : ''"
                  @focus="textareaFocus"
                  @blur="showPlaceHolder = true"
                />
                <div
                  class="bs-btn"
                  @click="handleBulletScreen(item.placeholder_words)"
                />
                <div v-show="showLight" class="light">
                  <img
                    src="https://resource.chunyu.mobi/@/media/images/2022/12/14/f628/40cd7ea861de_w193_h238_.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- 权威专家 -->
          <div
            v-if="item.unique_key === 'high_level_doctor_info'"
            class="high-level-doctor"
            :style="{ backgroundImage: 'url(' + item.background_image + ')' }"
          >
            <div class="pt-imgs">
              <div
                v-for="(img, index) in item.front_info_list"
                :key="index"
                class="pt-img-wrap"
              >
                <img
                  class="pt-img"
                  :src="img.doctor_image"
                  alt=""
                  @click="
                    jumpAppOrH5(img.doctor_url, {
                      click_position: img.click_position_doctor,
                    })
                  "
                />
                <div
                  class="pt-img-btn pt-img-btn-live"
                  @click.stop="
                    jumpAppOrH5(img.live_url, {
                      click_position: img.click_position_live,
                    })
                  "
                />
                <div
                  class="pt-img-btn pt-img-btn-qa"
                  @click.stop="
                    jumpAppOrH5(img.ask_url, {
                      click_position: img.click_position_ask,
                    })
                  "
                />
              </div>
            </div>
            <img
              src="https://staff.chunyu.mobi/@/media/images/2022/12/06/14d8/65d507e38860_w971_h287_.png"
              alt=""
              class="pt-btn"
              @click="
                jumpAppOrH5(item.btn_url, {
                  click_position: item.click_position_name,
                })
              "
            />
          </div>
          <!-- 直播 -->
          <div
            v-if="item.unique_key === 'live_info'"
            class="expert-live"
            :style="{ backgroundImage: 'url(' + item.background_image + ')' }"
          >
            <div class="el-imgs">
              <div
                v-for="(img, idx) in item.front_info_list"
                :key="idx"
                class="el-img"
                @click="
                  jumpAppOrH5(img.jump_url, {
                    click_position: img.click_position_name,
                  })
                "
              >
                <img :src="img.image" />
                <!-- 直播中 -->
                <div v-if="img.status == 'started'" class="tag">
                  <img
                    src="https://resource.chunyu.mobi/@/media/images/2022/09/16/0137/c6fe996124e1_w22_h25_.gif"
                  />
                  直播中
                </div>
                <!-- 直播前 -->
                <div
                  v-if="img.status == 'not_start'"
                  class="reverse-action-wrapper"
                >
                  <div class="live-time">{{ img.start_time }}</div>
                  <div v-if="!img.is_reserve" class="reverse-btn">预约</div>
                  <div v-else class="reverse-btn reversed">已预约</div>
                </div>
                <!-- 直播结束 -->
                <div v-if="img.status == 'finished'" class="tag tag-finished">
                  直播结束
                </div>
              </div>
            </div>
          </div>
          <!-- 抽签 -->
          <div
            v-if="item.unique_key === 'draw_info'"
            class="draw-info"
            :style="{ backgroundImage: 'url(' + item.background_image + ')' }"
          >
            <div
              class="di-btn"
              @click="
                jumpAppOrH5(item.jump_url, {
                  click_position: item.click_position_name,
                })
              "
            />
          </div>
          <!-- 视频 -->
          <div
            v-if="item.unique_key === 'warm_story_info'"
            class="video"
            :style="{ backgroundImage: 'url(' + item.background_image + ')' }"
          >
            <div class="player-wrap">
              <img
                v-if="!showVideo"
                class="live-cover"
                src="https://resource.chunyu.mobi/@/media/images/2022/12/20/82eb/9e1b8f753993_w937_h518_.png"
                alt=""
              />
              <img
                v-if="!showVideo"
                src="https://resource.chunyu.mobi/@/media/images/2022/07/07/d1d7/f1b64a8d0be2_w184_h184_.png"
                class="play-btn"
                @click="playVideo(item.click_position_name)"
              />
              <!-- v-show="showVideo" -->
              <video
                ref="video"
                x5-video-player-type="h5-page"
                :src="item.video_url"
                width="100%"
                webkit-playsinline="true"
                playsinline="true"
                controls
              />
            </div>
          </div>
          <!-- 特色服务 -->
          <div
            v-if="item.unique_key === 'special_service'"
            class="special-service"
            :style="{ backgroundImage: 'url(' + item.background_image + ')' }"
          >
            <div class="pt-imgs">
              <img
                v-for="(img, idx) in item.front_info_list"
                :key="idx"
                class="pt-img"
                :src="img.card_image"
                @click="
                  jumpAppOrH5(img.jump_url, {
                    click_position: img.click_position_name,
                  })
                "
              />
            </div>
          </div>
          <!-- 特惠专区 -->
          <div
            v-if="item.unique_key === 'discount_area_info'"
            class="discount-area-info"
            :style="{ backgroundImage: 'url(' + item.background_image + ')' }"
          >
            <div class="asi-imgs">
              <img
                v-for="(img, index) in item.front_info_list"
                :key="index"
                class="asi-img"
                :src="img.card_image"
                alt=""
                @click="
                  jumpAppOrH5(img.jump_url, {
                    click_position: img.click_position_name,
                  })
                "
              />
            </div>
          </div>
          <!-- 许愿池 -->
          <div
            v-if="item.unique_key === 'wish_pool_info'"
            class="wish-pool-info"
            :style="{ backgroundImage: 'url(' + item.background_image + ')' }"
            @touchstart.stop
          >
            <swiper
              v-if="list.length"
              class="swiper-wrap"
              :options="swiperOption"
            >
              <swiper-slide
                v-for="(img, index) in item.front_info_list"
                :key="index"
                ><div>
                  <img class="icon" :src="img.card_image" /></div
              ></swiper-slide>
            </swiper>
            <img
              :src="item.btn_image"
              alt=""
              class="si-btn"
              @click="
                jumpAppOrH5(item.btn_url, {
                  click_position: '首页去发帖',
                })
              "
            />
          </div>
          <!-- 小助手 -->
          <div
            v-if="item.unique_key === 'helper_info'"
            class="help-info"
            @click="
              addAdviser(item.h5_url, item.url_link, item.click_position_name)
            "
          />
          <!-- 金币任务 -->
          <!-- <div
            v-if="item.unique_key === 'hover_icon_info'"
            ref="coinBar"
            class="coin-mission"
            :style="{ backgroundImage: 'url(' + item.icon + ')' }"
            @click="doMission(item.jump_url, item.click_position_name)"
          /> -->
        </div>
      </div>
      <img
        class="bottom"
        src="https://staff.chunyu.mobi/@/media/images/2022/12/06/953c/13125f929099_w1125_h443_.jpg"
        alt=""
      />
    </div>
  </cube-sticky>
</template>

<script>
import * as cyDetect from '@cy/detect';
import cyShare from '@cy/share';
import { getThanksGivingHome, isLogin, sendBulletChat } from '@/services/index';
import { doPoint, requestEvent } from '@/utils/index';
import VBarrage from './components/VBarrage/index.vue';

const wx = require('weixin-js-sdk');

let vm = null;

export default {
  components: { VBarrage },
  data() {
    return {
      arr: [],
      isUserLogin: false,
      checkTop: false,
      swiperOption: {
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,
        slidesPerView: 1.31, // 设置slider容器能够同时显示的slides数量,可以是小数,设置为2时,如图所示，设置为3则会出现三张完整的active slide
        spaceBetween: -10,
        centeredSlides: true, // 设定为true时，active slide会居中，而不是默认状态下的居左
        loop: true,
        slideToClickedSlide: true, // true:点击slide会过渡到这个slide,默认false
        pagination: {
          el: '.swiper-pagination',
        },
        on: {
          click() {
            // 这里有坑，需要注意的是：this 指向的是 swpier 实例，而不是当前的 vue， 因此借助 vm，来调用 methods 里的方法
            // 当前活动块的索引，与activeIndex不同的是，在loop模式下不会将 复制的块 的数量计算在内。
            const { realIndex } = this;
            const index = vm.list.findIndex(
              item => item.unique_key === 'wish_pool_info'
            );
            if (index > -1) {
              vm.jumpAppOrH5(
                vm.list[index].front_info_list[realIndex].jump_url,
                {
                  click_position:
                    vm.list[index].front_info_list[realIndex]
                      .click_position_name,
                }
              );
            }
          },
        },
      },
      slideCurrent: 1,
      scrollY: 0,
      list: [],
      current: '', // 当前滚动位置的模块名
      timer: null,
      uniqueKeyList: [],
      listPos: {},
      handleTab: undefined,
      scrollTimer: null,
      scrollEnd: false,
      // tab图列表
      tabImgList: {
        tanks_word_info: {
          normal:
            'https://staff.chunyu.mobi/@/media/images/2022/12/05/0cec/cbbd83e2f0bd_w228_h106_.png',
          active:
            'https://staff.chunyu.mobi/@/media/images/2022/12/05/5992/ae945aa8eca5_w228_h106_.png',
        },
        draw_info: {
          normal:
            'https://staff.chunyu.mobi/@/media/images/2022/12/05/00c5/fe78c74f3a45_w228_h106_.png',
          active:
            'https://staff.chunyu.mobi/@/media/images/2022/12/05/c73c/3c235b33cd43_w228_h106_.png',
        },
        high_level_doctor_info: {
          normal:
            'https://staff.chunyu.mobi/@/media/images/2022/12/05/7bf4/7cd2fcd94998_w228_h106_.png',
          active:
            'https://staff.chunyu.mobi/@/media/images/2022/12/05/935f/b323fcb44355_w228_h106_.png',
        },
        live_info: {
          normal:
            'https://staff.chunyu.mobi/@/media/images/2022/12/05/4875/da752c36c934_w228_h106_.png',
          active:
            'https://staff.chunyu.mobi/@/media/images/2022/12/05/dbd0/369fb55dfda2_w228_h106_.png',
        },
        warm_story_info: {
          normal:
            'https://staff.chunyu.mobi/@/media/images/2022/12/05/7573/b173a2cce2fe_w228_h106_.png',
          active:
            'https://staff.chunyu.mobi/@/media/images/2022/12/05/745b/f2d266b95a28_w228_h106_.png',
        },
        special_service: {
          normal:
            'https://staff.chunyu.mobi/@/media/images/2022/12/05/33cc/672cdd875ebd_w228_h106_.png',
          active:
            'https://staff.chunyu.mobi/@/media/images/2022/12/05/82a3/ecebd57a742a_w228_h106_.png',
        },
        discount_area_info: {
          normal:
            'https://staff.chunyu.mobi/@/media/images/2022/12/05/2de0/6a4b888bd493_w228_h106_.png',
          active:
            'https://staff.chunyu.mobi/@/media/images/2022/12/05/2cd3/0ae18788a77b_w228_h106_.png',
        },
      },
      showVideo: false,
      text: '',
      bulletChat: {
        arr: [], // 传入的弹幕源数组
        isPause: false, // 控制是否暂停弹幕
        sendContent: null, // 自己发送的弹幕内容
        isJs: false, // 是否解析html
        direction: 'default',
      },
      currentId: 0,
      barrage: null,
      activityAlias: this.$route.query.activity_alias,
      showLight: false, // 是否展示发弹幕动效
      showAddOne: false, // 是否展示+1标签
      bulletLists: [],
      showPlaceHolder: true,
      sendBulletChatOne: {},
      initClientHeight: document.documentElement.clientHeight, // 页面原生高度
    };
  },
  computed: {
    bulletList() {
      const index = this.list.findIndex(
        i => i.unique_key === 'tanks_word_info'
      );
      const list = this.list[index].tanks_word_list.map(item => {
        return {
          direction: 'default',
          content: `
            <div class="bullet-item">
              <img src="${item.avatar}" />
              ${item.content}
            </div>
            `,
          isJs: true,
        };
      });
      return list;
    },
  },
  watch: {
    scrollY(n) {
      if (this.scrollTimer) clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(() => {
        if (n === this.scrollOld) {
          this.handleTab = '';
        }
      }, 200);
      this.scrollOld = n;
    },
    current(n) {
      if (!this.list.length) return;
      console.log(n);
      const index = this.list.findIndex(item => {
        return item.unique_key === n;
      });
      const { tabList } = this.$refs;
      const nodes = this.$refs.tabItem;
      const nodesLen = nodes ? nodes.length : 0;
      console.log('nodesLen', nodesLen);
      if (!nodes || !nodesLen) return;
      const halfIndex = Math.floor(nodes.length / 2);
      if (index > halfIndex) {
        this.timer = setTimeout(() => {
          tabList.scrollTo({
            left: 1000,
            top: 0,
          });
          clearTimeout(this.timer);
        }, 100);
      } else {
        tabList.scrollTo({
          left: 0,
          top: 0,
        });
      }
    },
  },
  created() {
    const tanksWord = this.$route.query.tanks_word;
    if (tanksWord) {
      sessionStorage.setItem('__TANKS_WORD__', tanksWord);
      this.$router.replace({
        name: 'CommonActivity',
        query: {
          activity_alias: this.activityAlias,
        },
      });
    }
    this.getThanksGivingHomeList();
    this.doPagePoint('ActivityPageView', {
      activity_name: '12月年终感恩活动',
      page_title: '幸好有你 点亮新年', // todo
    });
    vm = this;
  },
  mounted() {
    this.onShare();
  },
  methods: {
    textareaFocus() {
      this.showPlaceHolder = false;
      const u = navigator.userAgent;
      if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
        // 安卓手机
        //  拿到获取焦点的input
        // let input = document.querySelector('input')
        // input.addEventListener('focus', function() {
        window.onresize = () => {
          const curClientHeight = document.documentElement.clientHeight; // 当前页面高度

          if (curClientHeight < this.initClientHeight) {
            // 键盘弹出
            this.timer = setTimeout(function() {
              // 核心
              document.querySelector('#tanks_word_info').scrollIntoView(false);
              clearTimeout(this.timer);
            }, 200);
          } else {
            // 键盘收起
            document.querySelector('#textarea').blur();
            window.onresize = null; // 清空 onresize
          }
        };
        // this.timer = setTimeout(function() {
        //   // 核心
        //   document.querySelector('#tanks_word_info').scrollIntoView(false);
        //   // input.scrollIntoView(false);
        //   clearTimeout(this.timer);
        // }, 200);
        // });
      }
    },
    addAdviser(h5, urlLink, name) {
      if (cyDetect.isFromWechat()) {
        // 微信小程序环境下
        wx.miniProgram.getEnv(wxres => {
          if (wxres.miniprogram) {
            this.jumpAppOrH5(h5, {
              click_position: name,
            });
          } else {
            this.jumpAppOrH5(urlLink, {
              click_position: name,
            });
          }
        });
      } else {
        this.jumpAppOrH5(urlLink, {
          click_position: name,
        });
      }
    },
    /**
     * @description: 获取页面详情
     */
    getThanksGivingHomeList() {
      try {
        getThanksGivingHome({ activity_alias: this.activityAlias })
          .then(res => {
            const { error_code, error_msg, data } = res;
            if (error_code === 0) {
              this.list = data;
              this.current = this.list[0].unique_key;
              if (this.list.length) {
                this.uniqueKeyList = this.list.map(item => item.unique_key);
                this.$nextTick(() => {
                  this.getListPos();
                });
              }
              // 初始化弹幕数据
              this.bulletChatData();
              const tanksWord = sessionStorage.getItem('__TANKS_WORD__');
              if (tanksWord) {
                this.$nextTick(() => {
                  this.sendBulletScreen(tanksWord);
                  sessionStorage.removeItem('__TANKS_WORD__');
                });
              }
              this.$nextTick(() => {
                this.setWxMiniShare();
              });
            } else {
              this.toast(error_msg || '获取详情失败');
            }
          })
          .catch(e => {
            console.log(e);
          });
      } catch (e) {
        console.log(e);
      }
    },
    getListPos() {
      const list = {};
      this.uniqueKeyList.forEach((item, index) => {
        const el = document.querySelector(`#${item}`);
        const top = this.getElementTop(el);
        list[item] = {
          top,
          next: this.uniqueKeyList[index + 1] || '',
          index,
        };
      });
      this.listPos = list;
    },
    /**
     * 分享设置
     *
     */
    onShare() {
      const params = {
        page_title:
          '幸好有你 点亮新年，参与新年活动，发送感恩弹幕  赢千元京东卡 、200元话费充值、50元现金红包等好礼，立即参与活动', // 标题
        desc:
          '参与新年活动，发送感恩弹幕  赢千元京东卡 、200元话费充值、50元现金红包等好礼，立即参与活动', // 描述
        mini_image:
          'https://resource.chunyu.mobi/@/media/images/2022/12/16/bc4a/b22aa279f15c_w420_h340_.jpg',
        img:
          'https://resource.chunyu.mobi/@/media/images/2022/12/16/bc4a/b22aa279f15c_w420_h340_.jpg', // 分享的图片展示
        link: window.location.href,
        title:
          '幸好有你 点亮新年，参与新年活动，发送感恩弹幕  赢千元京东卡 、200元话费充值、50元现金红包等好礼，立即参与活动',
        userName: 'gh_681d3fd5683f', // 安卓
        mini_id: 'gh_681d3fd5683f', // IOS
        need_invitate_id: false,
        wx_scene_timeline_desc:
          '幸好有你 点亮新年，参与新年活动，发送感恩弹幕  赢千元京东卡 、200元话费充值、50元现金红包等好礼，立即参与活动',
        path: `/pages/h5_webview/index?url=${encodeURIComponent(
          window.location.href
        )}`,
      };
      cyShare.app(params);
    },
    /**
     * @description: 页面滚动事件
     * @param {*} e
     */
    scrollHandler(e) {
      const { scrollTop, clientHeight, scrollHeight } = e.currentTarget;
      this.scrollY = scrollTop;
      if (scrollTop + clientHeight === scrollHeight) {
        this.scrollEnd = true;
        this.maxScroll = scrollTop;
      } else {
        this.scrollEnd = false;
      }
      for (const item in this.listPos) {
        if (
          this.scrollY >= Number(this.listPos[item].top) - 50 &&
          this.scrollY < Number(this.listPos[this.listPos[item].next].top) - 50
        ) {
          if (this.handleTab) {
            this.current = this.handleTab;
          } else {
            this.current = item;
          }
          // this.handleTab = undefined;
        }
      }
      // if (this.$refs.coinBar) {
      //   this.$refs.coinBar.classList.add('translate-right');
      //   clearTimeout(this.timer);
      //   this.timer = setTimeout(() => {
      //     this.$refs.coinBar.classList.remove('translate-right');
      //     clearTimeout(this.timer);
      //   }, 2000);
      // }
    },
    /**
     * @description: 点击tab
     * @param {*} unique_key tab值
     */
    handleTabs({ unique_key }) {
      if (this.scrollEnd && this.maxScroll < this.listPos[unique_key].top) {
        this.current = unique_key;
      } else {
        const sel = this.$refs.qingxinWrap;
        this.handleTab = unique_key;
        sel.scrollTo({
          top: this.listPos[unique_key].top - 50,
          left: 100,
          behavior: 'smooth',
        });
      }
    },
    /**
     * 跳转逻辑
     *
     * @param {string} url 商品跳转链接
     * @param dopoint
     */
    async jumpAppOrH5(url, dopoint = {}) {
      if (Object.keys(dopoint)) {
        await this.doPagePoint('ActivityClick', {
          ...dopoint,
          activity_name: '12月年终感恩活动',
          page_title: '幸好有你 点亮新年',
        });
      }
      if (cyDetect.isFromCY()) {
        window.location.href = `${url}#OPEN_NEW_WIN`;
      } else if (cyDetect.isFromWechat()) {
        // 微信小程序环境下
        wx.miniProgram.getEnv(wxres => {
          if (wxres.miniprogram) {
            wx.miniProgram.navigateTo({
              url: `/pages/h5_webview/index?url=${encodeURIComponent(url)}`,
            });
          } else {
            window.location.href = url;
          }
        });
      } else {
        window.location.href = url;
      }
    },
    /**
     * @description: 请求登录状态
     * @param {*} url 未登录→登录后跳转的url，默认为当前页
     */
    login(url = '') {
      return new Promise((resolve, reject) => {
        isLogin()
          .then(res => {
            const { is_login } = res;
            if (!is_login) {
              requestEvent(url);
            } else {
              this.isUserLogin = true;
            }
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    /**
     * @param type
     * @param data
     * @param type
     * @param data
     * @description: dopoint
     */
    doPagePoint(type, data) {
      let app;
      if (cyDetect.isFromCY()) {
        app = '0';
      } else if (cyDetect.isFromCYClinic()) {
        app = '1';
        // eslint-disable-next-line no-underscore-dangle
      } else if (window.__wxjs_environment === 'miniprogram') {
        app = 'weixin_mini';
      }
      return doPoint(type, {
        app,
        ...data,
      });
    },
    getElementTop(elem) {
      let elemTop = elem.offsetTop; // 获得elem元素距相对定位的父元素的top

      elem = elem.offsetParent; // 将elem换成起相对定位的父元素

      while (elem != null) {
        // 只要还有相对定位的父元素

        // 获得父元素 距他父元素的top值,累加到结果中

        elemTop += elem.offsetTop; // 再次将elem换成他相对定位的父元素上;

        elem = elem.offsetParent;
      }

      return elemTop;
    },

    playVideo(name) {
      this.doPagePoint('AppClick', {
        click_position: name,
        activity_name: '12月年终感恩活动',
        page_title: '幸好有你 点亮新年', // todo
      });
      this.showVideo = true;
      this.$nextTick(() => {
        const video = document.querySelector('video');
        video.play();
      });
    },

    async handleBulletScreen(placeholderWords) {
      if (this.isUserLogin) {
        console.log('已登录');
        // sessionStorage.removeItem('__TANKS_WORD__');
        this.sendBulletScreen(placeholderWords);
      } else {
        console.log('设置__TANKS_WORD__');
        localStorage.setItem('__TANKS_WORD__', this.text || placeholderWords);
        const url = `${window.location.href}&tanks_word=${this.text ||
          placeholderWords}`;
        await this.login(url).catch(e => {
          console.log('登录请求出错：', e);
        });
        if (this.isUserLogin) {
          this.sendBulletScreen(placeholderWords);
          // sessionStorage.removeItem('__TANKS_WORD__');
        }
      }
    },

    sendBulletScreen(placeholderWords) {
      this.doPagePoint('ActivityClick', {
        click_position: '发送感恩语',
        activity_name: '12月年终感恩活动',
        page_title: '幸好有你 点亮新年', // todo
      });
      const text = this.text || placeholderWords || '';
      this.text = '';
      try {
        sendBulletChat(
          {
            content: text,
          },
          this.activityAlias
        )
          .then(res => {
            const { error_code, error_msg, data } = res;
            if (error_code !== 0) {
              this.$createToast({
                time: 1000,
                txt: error_msg || '发送失败',
                type: 'txt',
              }).show();
            } else {
              this.$createToast({
                time: 1000,
                txt: data.toast_txt || '发送成功',
                type: 'txt',
              }).show();
              if (data.icon) {
                this.showLight = true;
                this.timer = setTimeout(() => {
                  this.showLight = false;
                  this.showAddOne = true;
                  clearTimeout(this.timer);
                  this.timer = setTimeout(() => {
                    this.showAddOne = false;
                    clearTimeout(this.timer);
                  }, 1000);
                }, 1300);
              }
              console.log(111111112);
              this.sendBarrage({
                content: text,
                avatar: data.avatar,
              });
            }
          })
          .catch(e => {
            console.log(e);
            this.$createToast({
              time: 1000,
              txt: `发送失败`,
              type: 'txt',
            }).show();
          });
      } catch (e) {
        console.log(e);
        this.$createToast({
          time: 1000,
          txt: `发送失败`,
          type: 'txt',
        }).show();
      }
    },

    // 初始化弹幕数据
    bulletChatData() {
      const index = this.list.findIndex(
        i => i.unique_key === 'tanks_word_info'
      );
      const arr = this.list[index].bullet_chat_list;
      // const bulletList = [];
      // if (arr.length < 10) {
      //   for (let i = 0; i < 10; i++) {
      //     arr.push(...this.list[index].bullet_chat_list);
      //   }
      // }
      for (let i = 0; i < arr.length; i++) {
        const item = arr[i];
        this.bulletLists.push({
          direction: 'default',
          // eslint-disable-next-line radix
          content: `
            <div class="bullet-item">
              <img src="${item.avatar}" />
              ${item.content}
            </div>
            `,
          isJs: true,
        });
      }
      // this.bulletLists.push(...bulletList);
    },
    /**
     * @param url
     * @param name
     * @description: 点击金币任务
     */
    async doMission(url, name) {
      if (this.isUserLogin) {
        this.jumpAppOrH5(url, {
          click_position: name,
        });
      }
    },
    // 发送弹幕
    sendBarrage(info) {
      if (
        this.bulletLists.length > 1 &&
        this.text !== '' &&
        this.text !== null
      ) {
        console.log(111111);
        // this.bulletLists.unshift({
        //   isJs: true,
        //   // eslint-disable-next-line radix
        //   content: `
        //     <div class="bullet-item">
        //       <img src="${info.avatar}" />
        //       ${info.content}
        //     </div>
        //     `,
        //   direction: 'default',
        // });
        this.sendBulletChatOne = {
          isJs: true,
          // eslint-disable-next-line radix
          content: `
            <div class="bullet-item">
              <img src="${info.avatar}" />
              ${info.content}
            </div>
            `,
          direction: 'default',
        };
      } else {
        this.bulletLists.push({
          content: `
            <div class="bullet-item">
              <img src="${info.avatar}" />
              ${info.content}
            </div>
            `,
          direction: 'default',
          isJs: true,
        });
      }
      this.text = null;
    },
    /**
     * 设置微信小程序分享
     */
    setWxMiniShare() {
      if (cyDetect.isFromWechat()) {
        wx.miniProgram.getEnv(wxres => {
          if (wxres.miniprogram) {
            console.log('设置微信分享');
            wx.miniProgram.postMessage({
              data: {
                img: this.shareImg, // 分享的图片展示
                title:
                  '幸好有你 点亮新年，参与新年活动，发送感恩弹幕  赢千元京东卡 、200元话费充值、50元现金红包等好礼，立即参与活动', // 标题
                link: encodeURIComponent(`${window.location.href}`), // 分享后点击卡片的跳转链接
                origin: 'common-activity/lottery', // 来源
              },
            });
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.qingxin-wrap {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 100vh;
  padding: rem(317) 0 rem(0);
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
.bg-wrap {
  width: 100%;
  // margin: 0 rem(14);
  background: linear-gradient(
    180deg,
    #f4183f rem(30),
    #fc5a78 rem(60),
    #fc5a78 rem(2500),
    #d7517b rem(2700)
  );
}
.qx-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: rem(372);
  background-image: url('https://resource.chunyu.mobi/@/media/images/2022/12/15/8d1b/16abfb3b3c0d_w2246_h2229_.png');
  background-repeat: no-repeat;
  background-size: 100%;
}
.prepend-header {
  // width: 100%;
  height: rem(54);
  margin: 0 rem(15) rem(10);
  padding-top: rem(8);
  background: url('https://staff.chunyu.mobi/@/media/images/2022/12/05/42e7/f895fc49e8f3_w1039_h163_.png')
    no-repeat;
  background-size: 100% 100%;
  ul {
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    height: 100%;
    padding: rem(6) rem(8) rem(5) rem(4);
    overflow-x: auto;
    overflow-y: hidden;
    color: #006b89;
    font-size: 13px;
    line-height: 34px;
    border-radius: rem(35);
  }
  li {
    flex-shrink: 0;
    width: rem(76);
    padding: 0;
    text-align: center;
    &.active {
      margin-top: rem(-1);
    }
    img {
      width: rem(76);
      height: rem(35);
    }
  }
}
.tanks-word-info {
  position: relative;
  // width: 100%;
  height: rem(444);
  // margin-top: rem(10);
  padding: rem(195) rem(16) rem(20);
  background-repeat: no-repeat;
  background-size: 100%;
  .to-lottery {
    position: absolute;
    top: rem(102);
    right: rem(38);
    width: rem(34);
    height: rem(71);
  }
  .add-one {
    position: absolute;
    top: rem(83);
    right: rem(10);
    width: rem(60);
  }
  .bullet-screen {
    position: relative;
    width: rem(312);
    height: rem(188);
    margin: auto;
    background: url('https://resource.chunyu.mobi/@/media/images/2022/12/22/f5ba/5ee3f443a137_w1872_h1130_.png')
      no-repeat;
    background-size: 100%;
    .input-wrap {
      position: absolute;
      bottom: rem(-32);
      left: 50%;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: rem(300);
      height: rem(42);
      padding: rem(13) 0;
      padding-right: rem(4);
      background: url('https://staff.chunyu.mobi/@/media/images/2022/12/06/4acd/5fea571c09cb_w1802_h254_.png')
        no-repeat;
      background-size: 100% 100%;
      border-radius: 100px;
      transform: translateX(-50%);
      textarea {
        width: rem(222);
        max-height: 100%;
        padding-left: rem(10);
        color: #a73600;
        font-weight: 500;
        font-size: 12px;
        background: none;
        border: 0;
        outline: none;
        resize: none;
        @include placeholder {
          color: #a73600;
          font-weight: 500;
          font-size: 12px;
        }
      }
      .light {
        position: absolute;
        right: 0;
        bottom: rem(0);
        z-index: 200;
        width: rem(70);
        transform: translateX(rem(-10));
        opacity: 0;
        animation-name: up;
        animation-duration: 1.3s;
        animation-timing-function: linear;
        animation-fill-mode: backwards;
        @keyframes up {
          10% {
            transform: translate(rem(-10));
            opacity: 0.5;
          }
          15% {
            transform: translate(rem(0), rem(-25));
            opacity: 1;
          }
          50% {
            transform: translate(rem(29), rem(-100));
            opacity: 1;
          }
          80% {
            opacity: 0.7;
          }
          100% {
            transform: translate(rem(25), rem(-210));
            opacity: 0;
          }
        }
        img {
          width: 100%;
        }
      }
      .bs-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: rem(84);
        height: rem(44);
        margin-top: rem(0);
        margin-right: rem(-4);
        color: #050929;
        font-weight: 600;
        font-size: 15px;
        background: url('https://staff.chunyu.mobi/@/media/images/2022/12/06/b3e7/11ea96d72362_w496_h255_.png')
          no-repeat;
        background-size: 100%;
        border-radius: 100px;
      }
    }
  }
}
.high-level-doctor {
  position: relative;
  // width: 100%;
  height: rem(618);
  // margin: 0 rem(14);
  // margin-top: rem(9);
  padding: rem(84) rem(30) rem(17);
  background-repeat: no-repeat;
  background-size: 100%;
  .pt-imgs {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
    .pt-img-wrap {
      position: relative;
      padding-bottom: rem(10);
    }
    img {
      flex-shrink: 0;
      width: rem(153);
      height: rem(212);
    }
    .pt-img-btn {
      position: absolute;
      bottom: rem(22);
      width: rem(69);
      height: rem(26);
      &:last-child {
        right: rem(5);
      }
      &.pt-img-btn-live {
        left: rem(5);
      }
    }
  }
  .pt-btn {
    display: block;
    width: rem(162);
    height: rem(48);
    margin: rem(5) auto 0;
  }
}
.expert-live {
  // width: 100%;
  height: rem(311);
  // margin: 0 rem(14);
  // margin-top: rem(10);
  padding: rem(98) rem(23) rem(17) rem(22);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .el-imgs {
    display: flex;
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    .el-img {
      position: relative;
      width: rem(141);
      height: rem(188);
      margin: 0 rem(8) 0 rem(9);
      .tag {
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        width: rem(50);
        height: rem(19);
        padding-left: rem(7);
        color: #fff;
        font-size: 8px;
        background: linear-gradient(90deg, #fe403a, #fe905f);
        border-radius: rem(10) 0 rem(10) 0;
        &-finished {
          background: rgba(0, 0, 0, 0.3);
        }
        img {
          width: rem(7);
          height: rem(6);
          margin-right: rem(3);
        }
      }
      .reverse-action-wrapper {
        position: absolute;
        bottom: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: rem(38);
        padding: rem(15) rem(5);
        background-image: linear-gradient(
          180deg,
          rgba(0, 0, 0, 0) 2%,
          rgba(0, 0, 0, 0.58) 100%
        );
        border-radius: 0 0 8px 8px;
      }
      .live-time {
        flex: 1;
        color: #fff;
        font-size: 11px;
      }
      .reverse-btn {
        flex: 0 0 auto;
        height: rem(24);
        padding: 0 rem(13);
        color: #fff;
        font-size: 12px;
        line-height: rem(24);
        text-align: center;
        background-color: #39d167;
        border-radius: rem(17);

        &.reversed {
          background-color: #c2c2c2;
        }
      }
      > img {
        width: rem(141);
        height: rem(188);
        border-radius: 8px;
      }
    }
  }
  .el-btn {
    display: block;
    width: rem(172);
    height: rem(40);
    margin: rem(12) auto 0;
  }
}
.wish-pool-info {
  // width: 100%;
  height: rem(337);
  // margin: 0 rem(14);
  // margin-top: rem(10);
  padding: rem(84) rem(23) rem(15);
  background-repeat: no-repeat;
  background-size: 100%;
  .si-content-wrap {
    width: rem(262);
    // height: rem(160);
    margin: auto;
  }
  .swiper-container {
    padding-bottom: rem(13);
  }
  .swiper-slide {
    transform: scale(0.8);
    // transition: 0.1s;
  }
  .icon {
    width: 100%;
    max-height: 100%;
  }
  //swriper自带的类名（选中时的样式）
  .swiper-slide-active {
    transform: scale(1);
  }
  .swiper-pagination {
    bottom: rem(0);
    left: 50%;
    transform: translateX(-50%);
  }
  ::v-deep .swiper-pagination-bullet {
    width: rem(5);
    height: rem(5);
    margin-right: rem(3);
    background: #e4e4e4;
    border-radius: 50%;
    &.swiper-pagination-bullet-active {
      width: rem(9);
      background: #16759c;
      border-radius: 3px;
    }
  }

  .swiper-wrap {
    max-height: 100%;
    overflow: hidden;
    transform: translate3d(0, 0, 0);
  }
  .si-btn {
    display: block;
    width: rem(162);
    height: rem(48);
    margin: auto;
  }
}
.discount-area-info {
  // width: 100%;
  height: rem(296);
  // margin: 0 rem(14);
  // margin-top: rem(9);
  padding: rem(85) rem(30) rem(17);
  overflow: hidden;
  background-repeat: no-repeat;
  background-size: 100%;
  .asi-imgs {
    display: flex;
    justify-content: space-between;
    width: 100%;
    img {
      width: rem(152);
      height: rem(180);
    }
  }
  .asi-btn {
    display: block;
    width: rem(172);
    height: rem(40);
    margin: rem(12) auto 0;
  }
}
.coin-mission {
  position: fixed;
  right: 0;
  bottom: rem(123);
  z-index: 10;
  width: rem(72);
  height: rem(72);
  background-image: url('https://resource.chunyu.mobi/@/media/images/2022/09/16/8b51/3f0bbb8a9afd_w216_h216_.gif');
  background-repeat: no-repeat;
  background-size: 100%;
  transition: right 300ms;
  &.translate-right {
    right: rem(-50);
  }
}

.draw-info {
  // width: 100%;
  height: rem(364);
  // margin: 0 rem(14);
  // margin-top: rem(9);
  padding: rem(288) rem(16) rem(17);
  overflow: hidden;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .di-btn {
    width: rem(162);
    height: rem(48);
    margin: auto;
    background: url('https://staff.chunyu.mobi/@/media/images/2022/12/06/d94c/52fe1db4bcec_w971_h288_.png')
      no-repeat;
    background-size: 100% 100%;
  }
}

.video {
  // width: 100%;
  height: rem(302);
  margin: 0 auto 0;
  // margin: 0 rem(14);
  background-repeat: no-repeat;
  background-size: 100%;
  .player-wrap {
    position: relative;
    top: rem(99);
    width: rem(313);
    height: rem(173);
    margin: auto;
    padding: rem(2);
    overflow: hidden;
    border-radius: rem(10);
    // background: linear-gradient(0deg, #f8c7d5, #9995ef);
    img.live-cover {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
    }
    img.play-btn {
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 1;
      width: rem(46);
      height: rem(46);
      transform: translate(-50%, -50%);
    }
  }
  video {
    width: 100%;
    height: 100%;
    object-fit: fill;
    background: black;
  }
}

.special-service {
  position: relative;
  // width: 100%;
  height: rem(492);
  // margin: 0 rem(14);
  // margin-top: rem(9);
  padding: rem(99) rem(30) rem(17);
  background-repeat: no-repeat;
  background-size: 100%;
  .pt-imgs {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
    img {
      flex-shrink: 0;
      width: rem(101);
      height: rem(180);
      margin-bottom: rem(8);
    }
  }
}

.help-info {
  // width: 100%;
  height: rem(52);
  margin: rem(15) rem(14) 0;
  background: url('https://staff.chunyu.mobi/@/media/images/2022/12/06/f103/c266577f4240_w2069_h311_.png')
    no-repeat;
  background-size: 100%;
}
// ::v-deep .cube-scroll-nav {
// }
::v-deep .cube-sticky-fixed {
  // padding: 0 rem(15);
}

.bottom {
  display: block;
  width: 100%;
}

::v-deep .barrage-wrapper .barrage-main {
  top: rem(18);
  left: rem(2);
  width: rem(308);
  height: rem(132);
}
#bullet-screen-wrap {
  width: rem(308);
  height: rem(144);
}

::v-deep .bullet-item {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  height: rem(24);
  margin-right: rem(10);
  padding: 0 rem(8) 0 rem(5);
  color: #a73600;
  font-weight: 600;
  font-size: 10px;
  line-height: rem(24);
  white-space: nowrap;
  background: #ffe4a5;
  border-radius: 23px;
  img {
    width: rem(19);
    height: rem(19);
    margin-right: rem(4);
    border-radius: 30px;
  }
}
</style>
